var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEffieientInterSche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 99.081,
    height: 104.265,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(-506 -2511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    transform: "translate(513 2516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M79.936,48.282A39.968,39.968,0,1,1,39.967,8.313,39.968,39.968,0,0,1,79.936,48.282",
    transform: "translate(0 0.375)",
    fill: "#e3d6ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M76.859,100.738H69.908A1.737,1.737,0,0,1,68.17,99V79.884a1.737,1.737,0,0,1,1.738-1.738h6.951A1.736,1.736,0,0,1,78.6,79.884V99a1.736,1.736,0,0,1-1.737,1.738m-5.213-3.476h3.475V81.622H71.646Z",
    transform: "translate(3.077 3.527)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M30.3,100.738h-6.95A1.737,1.737,0,0,1,21.615,99V79.884a1.737,1.737,0,0,1,1.738-1.738H30.3a1.737,1.737,0,0,1,1.738,1.738V99a1.737,1.737,0,0,1-1.738,1.738M25.09,97.262h3.475V81.622H25.09Z",
    transform: "translate(0.976 3.527)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M66.855,68.171H35.309A12.03,12.03,0,0,0,23.278,80.2l6.951,5.347v13.9H71.935v-13.9l6.95-5.347A12.03,12.03,0,0,0,66.855,68.171",
    transform: "translate(1.051 3.077)",
    fill: "#6276e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M72.009,101.263H30.3a1.737,1.737,0,0,1-1.738-1.738V86.478l-6.273-4.824a1.738,1.738,0,0,1-.677-1.377A13.782,13.782,0,0,1,35.383,66.509H66.93A13.781,13.781,0,0,1,80.7,80.277a1.74,1.74,0,0,1-.679,1.377l-6.272,4.824V99.525a1.736,1.736,0,0,1-1.737,1.738M32.041,97.787h38.23V85.624a1.74,1.74,0,0,1,.678-1.379l6.238-4.8A10.307,10.307,0,0,0,66.93,69.983H35.383a10.306,10.306,0,0,0-10.258,9.464l6.237,4.8a1.741,1.741,0,0,1,.679,1.379ZM78.961,80.276h0Z",
    transform: "translate(0.976 3.002)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M50.587,76.225A4.721,4.721,0,0,1,45.866,71.5V60.946A1.245,1.245,0,0,1,47.112,59.7h6.951a1.246,1.246,0,0,1,1.246,1.246V71.5a4.721,4.721,0,0,1-4.722,4.721",
    transform: "translate(2.07 2.694)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M50.661,78.038A6.465,6.465,0,0,1,44.2,71.58V61.022a2.988,2.988,0,0,1,2.984-2.985h6.95a2.988,2.988,0,0,1,2.984,2.985V71.58a6.465,6.465,0,0,1-6.459,6.458M47.678,61.513V71.58a2.983,2.983,0,0,0,5.966,0V61.513Z",
    transform: "translate(1.995 2.619)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M92.288,14.646A12.984,12.984,0,1,1,79.3,1.663,12.983,12.983,0,0,1,92.288,14.646",
    transform: "translate(2.993 0.075)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M79.379,29.443A14.721,14.721,0,1,1,94.1,14.721,14.739,14.739,0,0,1,79.379,29.443m0-25.967A11.247,11.247,0,1,0,90.624,14.721,11.259,11.259,0,0,0,79.379,3.475",
    transform: "translate(2.918 0)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M8.313,23.278V46.506a6.313,6.313,0,0,0,6.313,6.313H46.04A7.454,7.454,0,0,0,53.5,45.366V23.278Z",
    transform: "translate(0.375 1.05)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M46.114,54.632H14.7a8.059,8.059,0,0,1-8.051-8.05V23.353a1.737,1.737,0,0,1,1.738-1.738H53.569a1.737,1.737,0,0,1,1.738,1.738V45.439a9.2,9.2,0,0,1-9.193,9.193M10.126,25.09V46.582A4.579,4.579,0,0,0,14.7,51.157H46.114a5.724,5.724,0,0,0,5.718-5.718V25.09Z",
    transform: "translate(0.3 0.975)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M47.97,11.638H13.838a5.525,5.525,0,0,0-5.525,5.526V23.8H53.494V17.164a5.526,5.526,0,0,0-5.525-5.526",
    transform: "translate(0.375 0.525)",
    fill: "#1d37fc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M53.569,25.615H8.388A1.736,1.736,0,0,1,6.65,23.878V17.24a7.272,7.272,0,0,1,7.264-7.264H48.045a7.272,7.272,0,0,1,7.263,7.264v6.639a1.736,1.736,0,0,1-1.738,1.737M10.126,22.14H51.832v-4.9a3.792,3.792,0,0,0-3.789-3.788H13.914a3.791,3.791,0,0,0-3.788,3.788Z",
    transform: "translate(0.3 0.45)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M39.98,17.152a1.736,1.736,0,0,1-1.738-1.737V6.727a1.738,1.738,0,1,1,3.475,0v8.688a1.736,1.736,0,0,1-1.737,1.737",
    transform: "translate(1.726 0.225)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M20.027,17.152a1.736,1.736,0,0,1-1.737-1.737V6.727a1.738,1.738,0,1,1,3.475,0v8.688a1.736,1.736,0,0,1-1.738,1.737",
    transform: "translate(0.826 0.225)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M82.409,19.695a1.748,1.748,0,0,1-.775-.183L76.912,17.15a1.735,1.735,0,0,1-.96-1.554V8.513a1.738,1.738,0,1,1,3.475,0v6.01l3.76,1.881a1.737,1.737,0,0,1-.779,3.291",
    transform: "translate(3.428 0.305)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M68.562,45.874c0,11.632-5.693,21.247-17.427,21.247S33.708,57.506,33.708,45.874,39.4,24.627,51.136,24.627,68.562,34.24,68.562,45.874",
    transform: "translate(1.521 1.111)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M51.211,68.931c-11.642,0-19.164-9.022-19.164-22.982s7.522-22.985,19.164-22.985S70.374,31.987,70.374,45.95,62.852,68.931,51.211,68.931m0-42.491c-11.568,0-15.689,10.077-15.689,19.509s4.121,19.506,15.689,19.506S66.9,55.379,66.9,45.949,62.778,26.44,51.211,26.44",
    transform: "translate(1.447 1.036)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M66.126,37.7a16.031,16.031,0,1,1-.267,19.272L58.541,56.1l5.168-3.166A15.959,15.959,0,0,1,66.126,37.7",
    transform: "translate(2.642 1.423)",
    fill: "#3a67ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M78.786,65.3A17.589,17.589,0,0,1,65,58.683l-6.59-.786a1.739,1.739,0,0,1-.7-3.208l4.01-2.457A17.713,17.713,0,1,1,78.786,65.3M63.792,55.037l2.347.28a1.75,1.75,0,0,1,1.2.7,14.252,14.252,0,1,0-1.917-3.6,1.737,1.737,0,0,1-.727,2.069Z",
    transform: "translate(2.567 1.349)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M85.248,43.38H76.56a1.738,1.738,0,1,1,0-3.475h8.688a1.738,1.738,0,0,1,0,3.475",
    transform: "translate(3.377 1.801)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M85.248,48.368H76.56a1.738,1.738,0,1,1,0-3.475h8.688a1.738,1.738,0,0,1,0,3.475",
    transform: "translate(3.377 2.026)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M73.726,41.811A1.906,1.906,0,1,1,71.82,39.9a1.905,1.905,0,0,1,1.905,1.906",
    transform: "translate(3.156 1.801)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M73.726,46.8a1.906,1.906,0,1,1-1.905-1.906A1.905,1.905,0,0,1,73.726,46.8",
    transform: "translate(3.156 2.026)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M85.248,53.356H76.56a1.738,1.738,0,1,1,0-3.475h8.688a1.738,1.738,0,0,1,0,3.475",
    transform: "translate(3.377 2.251)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M73.726,51.787a1.906,1.906,0,1,1-1.905-1.906,1.905,1.905,0,0,1,1.905,1.906",
    transform: "translate(3.156 2.251)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M21.99,33.4H15.039a1.738,1.738,0,0,1,0-3.476H21.99a1.738,1.738,0,0,1,0,3.476",
    transform: "translate(0.6 1.351)",
    fill: "#13154c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M21.99,40.055H15.039a1.738,1.738,0,0,1,0-3.475H21.99a1.738,1.738,0,1,1,0,3.475",
    transform: "translate(0.6 1.651)",
    fill: "#13154c"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_260",
    "data-name": "Rectangle 260",
    width: 114,
    height: 114,
    transform: "translate(506 2511)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEffieientInterSche);
export default __webpack_public_path__ + "static/media/effieientInterSche.ebceae92ef2ef624c1d54b3e5c4d324d.svg";
export { ForwardRef as ReactComponent };